import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../slices/staffSlice';
import { fetchRequests } from '../Requests/getRequests';
import { show } from '../slices/toastSlice';
import { authStaff } from '../utils/constants';
import { useNavigate } from 'react-router-dom';

// Fetches all transactions for a specific mandate by its Npontu mandate ID
function useNpontuMandateTransactions({ mandateId }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [isLoading, setIsLoading] = useState(true);
    const [mandateTransactions, setMandateTransactions] = useState([]);

    useEffect(() => {
        if (!mandateId) return;

        let unsubscribed = false;

        const getMandateTransactions = async() => {
            setIsLoading(true);
            setMandateTransactions([]);

            let headers = authStaff(accessToken);
            let url = `/payments/npontu/mandate/transactions`;
            let params = { id: mandateId };

            let res = await fetchRequests(url, "GET", headers, params, {});
            setIsLoading(false);

            if(res?.code === 401){
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({
                    type : "error",
                    state : true,
                    message : "Your session has expired. Please login to continue."
                }));
                return;
            }

            if(res?.err){
                dispatch(show({
                    type : "error",
                    state : true,
                    message : res?.err
                }));
                return;
            }

            if(!unsubscribed){
                setMandateTransactions(res?.data?.data ?? []);
            }
        }

        getMandateTransactions();

        return () => {
            unsubscribed = true;
        }
    }, [dispatch, navigate, accessToken, mandateId])

    return { isLoading, mandateTransactions }
}

export default useNpontuMandateTransactions
